import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

interface Props {
  isCompliant: boolean;
  label: 'Yes' | 'No';
}

export default function RuleComplianceIndicator({ isCompliant, label }: Props) {
  return (
    <Stack
      direction="row"
      spacing={0.875}
      alignItems="center"
      sx={{ color: isCompliant ? 'success.main' : 'warning.main', fontWeight: 700, whiteSpace: 'nowrap' }}
    >
      <Box
        component="span"
        sx={{
          bgcolor: isCompliant ? 'success.main' : 'warning.main',
          borderRadius: '50%',
          boxShadow: '0 0 0 2px rgba(0,0,0,0.04)',
          height: 10,
          width: 10,
        }}
      />
      <Typography variant="body2" fontWeight={700}>
        {label}
      </Typography>
    </Stack>
  );
}
